import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import { ONBOARDING_STATUS_LABEL, ONBOARDING_STATUS_TONE } from '../../Consts/onboardings.const';
import {
  OnboardingMarketResponse,
  OnboardingOrganizationResponse,
  OnboardingResponse,
  OnboardingUserResponse,
} from '../../Interfaces/api/backoffice/onboarding.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class OnboardingFunnelEntry {
  id = '';
  status = '';
  tenant_id: string | null = null;
  organization: OnboardingOrganizationResponse | null = null;
  user: OnboardingUserResponse | null = null;
  market: OnboardingMarketResponse | null = null;
  admin_consent_granted_at: string | null = null;
  created_at: string | null = null;
  updated_at: string | null = null;

  constructor(data: Partial<OnboardingResponse> = {}) {
    Object.assign(this, data);
  }

  get statusLabelKey(): string {
    return ONBOARDING_STATUS_LABEL[this.status] || this.status;
  }

  get statusTone(): StatusTone {
    return ONBOARDING_STATUS_TONE[this.status] || 'neutral';
  }

  get organizationName(): string {
    return this.organization?.name || this.organization?.domain || VALUE_UNRESOLVED;
  }

  get contactEmail(): string {
    return this.user?.email || VALUE_UNRESOLVED;
  }

  get hasConsent(): boolean {
    return this.admin_consent_granted_at !== null;
  }

  get canReconsent(): boolean {
    return Boolean(this.tenant_id);
  }
}
